// DS9.7.5
import React from 'react';
import DeviationBlockedOverlay from './DeviationBlocked';
import ArtistBlockedOverlay from './ArtistBlocked';
import DefaultBlockedOverlay from './DefaultBlocked';
import AntisocialBlockedOverlay from './AntisocialBlocked';
import { BlockReasons } from '../../Moderation/redux/types';
import MatureAnonymousBlockedOverlay from './MatureAnonymousBlocked';
import MatureBlockedOverlay from './MatureBlocked';
import MatureAgeBlockedOverlay from './MatureAgeBlocked';
import MatureStrictBlockedOverlay from './MatureStrictBlocked';
import NsfgBlockedOverlay from './NsfgBlocked';
import { HiddenProps } from './types';

const BlockedOverlay: React.FC<HiddenProps> = props => {
  switch (props.blockReason) {
    case BlockReasons.DeviationBlocked:
      return <DeviationBlockedOverlay {...props} />;
    case BlockReasons.ArtistBlocked:
      return <ArtistBlockedOverlay {...props} />;
    case BlockReasons.MatureFilter:
      return <MatureBlockedOverlay {...props} />;
    case BlockReasons.MatureLoggedOut:
      return <MatureAnonymousBlockedOverlay {...props} />;
    case BlockReasons.MatureAge:
      return <MatureAgeBlockedOverlay {...props} />;
    case BlockReasons.StrictMatureAge:
      return <MatureStrictBlockedOverlay {...props} />;
    case BlockReasons.Antisocial:
      return <AntisocialBlockedOverlay {...props} />;
    case BlockReasons.Nsfg:
      return <NsfgBlockedOverlay {...props} />;
    case BlockReasons.BlockedByArtist:
    default:
      return <DefaultBlockedOverlay {...props} />;
  }
};
BlockedOverlay.displayName = 'BlockedOverlay';

export default BlockedOverlay;
